module.exports = __webpack_public_path__ + "img/lizhiyanwobing.abc25b8f.jpg";